import { useMemo } from 'react';
import { Stack } from 'expo-router';
import { useTheme } from '../../../../src/theme/useTheme';
import { getWorldcupStyles } from '../../../../appStyles/_worldcup.styles';

export default function WorldCupMatchStatsLayout() {
  const theme = useTheme();
  const styles = useMemo(() => getWorldcupStyles(theme, { safeAreaTop: 0 }), [theme]);

  return (
    <Stack
      screenOptions={{
        headerShown: false,
        contentStyle: styles.stackContentStyle,
        // Parent worldcup Stack owns presentation + animation for this group.
        // Inner Stack shows [matchId] as its initial (only) screen — no animation needed.
        animation: 'none',
        gestureEnabled: false,
      }}
    />
  );
}
